module.exports = "//cdn.mxpnl.com/static/asset-cache/41798e12732180be8b676713384604ce/iron/common/components/spinner/hearts.gif";